import { ReactNode } from 'react';

import * as S from './style';
import { Spinner } from '../';
import { PortalContainer } from '../PortalContainer';

export interface FullSpinnerProps {
  message?: ReactNode;
}

export default function FullSpinner({ message }: FullSpinnerProps) {
  return (
    <PortalContainer
      className="spinner"
      customStyle={{
        position: 'fixed',
        top: '0',
        left: '0',
        zIndex: '99999999',
        width: '100vw',
        height: '100vh',
      }}
    >
      <S.Wrapper style={{}}>
        <S.SpinnerWrapper>
          <Spinner />
          {message && <S.Message>{message}</S.Message>}
        </S.SpinnerWrapper>
        <S.Bg />
      </S.Wrapper>
    </PortalContainer>
  );
}
